import {
  copyFileById,
  destroyFile,
  getPictureUrlDatePath,
  getTokenHeader
} from "@/helpers/commonHelper";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import axios from "axios";
import APIKeyList from "@/components/Common/APIKeyList/APIKeyList.vue";
import NewsAPIKeyEditView from "@/components/News/NewsAPIKeyEditView/NewsAPIKeyEditView.vue";
import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import _ from "lodash";
import { uploadFile } from "@/helpers/fileHelper";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";

const defaultConfig = {
  containByCategoryGroupIds: [],
  containByCategoryTypeIds: [],
  containByCategoryIds: [],
  containByFeatureIds: [],
  showReleased: false,
  showHighlightToTop: false,
  showHighlight: false,
  defaultSorting: false,
  defaultDirection: false,
  showPoiFilterOutside: false,
  hitsPerPage: 10,
  startPage: 1,
  showSubscribeButton: false,
  showSubscriberPopup: false,
  subscriberPopupTimeout: 60,
  startOffset: 0,
  outputLang: "",
  showTextSearchOutside: false,
  showFiltersOutlined: false,
  ipWhitelist: "",
  rssDetailLink: "",
  showPoiFilter: false,
  poiFilterLabel: "Vereine",
  displayMap: false,
  displayLocationDistrict: false,
  displayLocationCity: false,
  displayLocationCountry: false,
  displayCurrentlyOpen: false,
  disableFilter: false,
  disableSortSelector: false,
  showMap: false,
  subTitleInsteadOfDescription: false,
  fallbackPicture: null,
  adminMailAddresses: [],
  formUser: null,
  dataFormName: "",
  hidePrivacyPolicy: false,
  privacyPolicyLink: "",
  privacyPolicyText:
    "Ich versichere die Richtigkeit der gemachten Angaben, dass die hochgeladenen Bilder rechtmäßig verwendet werden dürfen und alle abgebildeten Personen der Veröffentlichung zugestimmt haben. *",
  mailSubject: "",
  mailText: "",
  descriptionInfoText: "",
  groupFeaturesInGroups: false,
  createWidgetFeatureGroups: [],
  requireImage: false,
  requireImageCopyright: false,
  requireImageAIAttribution: false,
  mailSenderName: "EO.Heimat",
  dsgvoLink: "",
  dsgvoText:
    "Hier kann mit Deiner Einwilligung ein externer Inhalt angezeigt werden, der den redaktionellen Text ergänzt. Indem Du den Inhalt über „Akzeptieren und anzeigen“ aktivierst, kann der Anbieter der Videoplattform (z.B: YouTube) Informationen auf Deinem Gerät speichern oder abrufen und Deine personenbezogenen Daten erheben und verarbeiten, auch in Staaten außerhalb der EU mit einem niedrigeren Datenschutzniveau, worin Du ausdrücklich einwilligst. Die Einwilligung, kann von Dir wieder entzogen werden, indem Du Cookies & Cache löscht.",
  color: {
    "color-text": "#333",
    "color-primary": "#00636C",
    "color-secondary": "#00636C",
    "color-accent": "#00636C",
    "color-error": "#ff0000",
    "color-info": "#50727C",
    "color-warning": "#E4CC37"
  },
  cardStyle: "standard",
  cardBackgroundColor: "#fff",
  cardBorderRadius: 0,
  cardShowNewsDate: true,
  teaserAsSlider: true,
  showTeaserShowAllButton: false,
  disableTopicSelection: false,
  topicSelectionLabel: "Themen",
  topicSelectionStyle: "cloud",
  topicSelectionItem: ["keywords", "features"],
  overlayMode: "dark",
  expireInDays: 0,
  openDetailViewInNewTab: false,
  principalLabels: [],
  showPrincipalLabels: false,
  setNewsDefaultDate: false,
  showPagination: true,
  teaserMaxLength: 300,
  alternateOutput: "web",
  featuresStyle: "chips",
  newsIssuesWidget: {
    showReleaseYear: true,
    showReleaseMonth: true,
    showFilter: true,
    sortDirection: "desc",
    color: {
      "color-button": "#00636C",
      "color-background": "#00636C",
      "color-text": "#fff",
      "color-icon": "#fff"
    }
  },
  fileSizeConstrains: {
    active: false,
    unit: [],
    px: {
      min: { width: null, height: null },
      max: { width: null, height: null }
    },
    kb: {
      min: null,
      max: null
    }
  },
  userPermission: "none",
  isApp: false
};

export default {
  name: "NewsAdmin",
  async mounted() {
    try {
      await this.$store.dispatch("getAllUsers");
      await this.$store.dispatch("getNewsConfig");
      this.initializeChannelFileSizeConstrains();
      await this.$store.dispatch("getNewsApiKeys");
    } catch (error) {
      await this.$store.dispatch("createError", error);
    }
  },
  data: () => ({
    channels: [
      {
        value: "web",
        title: "Web"
      },
      {
        value: "gemeindeblatt",
        title: "Gemeindeblatt"
      },
      {
        value: "app",
        title: "App"
      }
    ],
    changedDescription: [],
    ownChannelsToUpdate: [],
    defaultChannelValues: ["web", "app", "gemeindeblatt"],
    editChannel: [],
    editedKey: _.cloneDeep(defaultConfig),
    errorList: [],
    validationDialog: false,
    dialog: false,
    MAIN_GREEN: "#00636C",
    imageFileSizeUnits: ["px", "kb"],
    expandedStandardChannels: [],
    expandedOwnChannels: []
  }),
  methods: {
    getPrincipalPaletteColors(moduleKey, widgetKey) {
      const colorPalette = this.$store.state.selectedPrincipal?.colorPalette;
      const colors = colorPalette?.[moduleKey]?.[widgetKey]?.colors;
      if (!Array.isArray(colors)) {
        return {};
      }
      return colors.reduce((acc, color) => {
        if (color?.key && color?.value) {
          acc[color.key] = color.value;
        }
        return acc;
      }, {});
    },
    getDefaultApiKeyConfig() {
      const baseConfig = _.cloneDeep(defaultConfig);
      baseConfig.color = {
        ...defaultConfig.color,
        ...this.getPrincipalPaletteColors("news", "widget")
      };
      baseConfig.newsIssuesWidget.color = {
        ...defaultConfig.newsIssuesWidget.color,
        ...this.getPrincipalPaletteColors("news", "newsIssuesWidget")
      };
      return baseConfig;
    },
    parseNumberOrFallback(value, fallback = null) {
      if (value === null || value === undefined || value === "") {
        return fallback;
      }
      const parsedValue = Number(value);
      return Number.isFinite(parsedValue) ? parsedValue : fallback;
    },
    fileSizeConstraintNumberRule(value) {
      return (!isNaN(value) && value > 0) || "Muss eine Zahl sein";
    },
    extractExistingFileSizeConstrains(channel) {
      const constrainsContainer = channel?.fileSizeConstrains;
      if (!constrainsContainer || typeof constrainsContainer !== "object") {
        return {};
      }
      if (constrainsContainer.fileSizeConstrains) {
        return constrainsContainer.fileSizeConstrains;
      }
      if (constrainsContainer.imagesSizeConstrains) {
        return constrainsContainer.imagesSizeConstrains;
      }
      if (constrainsContainer.images) {
        return constrainsContainer.images;
      }
      if (
        "active" in constrainsContainer ||
        "unit" in constrainsContainer ||
        "px" in constrainsContainer ||
        "kb" in constrainsContainer
      ) {
        return constrainsContainer;
      }
      return {};
    },
    normalizeChannelConstrains(channel) {
      if (!channel) return;
      const defaultFileSizeConstrains = _.cloneDeep(
        defaultConfig.fileSizeConstrains
      );
      const existingFileSizeConstrains = this.extractExistingFileSizeConstrains(
        channel
      );
      const existingUnits = Array.isArray(existingFileSizeConstrains.unit)
        ? existingFileSizeConstrains.unit
        : typeof existingFileSizeConstrains.unit === "string"
        ? [existingFileSizeConstrains.unit]
        : [];
      const normalizedUnits = existingUnits.filter(unit =>
        this.imageFileSizeUnits.includes(unit)
      );

      channel.fileSizeConstrains = {
        active:
          typeof existingFileSizeConstrains.active === "boolean"
            ? existingFileSizeConstrains.active
            : defaultFileSizeConstrains.active,
        unit:
          normalizedUnits.length || !defaultFileSizeConstrains.active
            ? normalizedUnits
            : [...defaultFileSizeConstrains.unit],
        px: {
          min: {
            width: this.parseNumberOrFallback(
              existingFileSizeConstrains.px?.min?.width,
              defaultFileSizeConstrains.px.min.width
            ),
            height: this.parseNumberOrFallback(
              existingFileSizeConstrains.px?.min?.height,
              defaultFileSizeConstrains.px.min.height
            )
          },
          max: {
            width: this.parseNumberOrFallback(
              existingFileSizeConstrains.px?.max?.width,
              defaultFileSizeConstrains.px.max.width
            ),
            height: this.parseNumberOrFallback(
              existingFileSizeConstrains.px?.max?.height,
              defaultFileSizeConstrains.px.max.height
            )
          }
        },
        kb: {
          min: this.parseNumberOrFallback(
            existingFileSizeConstrains.kb?.min,
            defaultFileSizeConstrains.kb.min
          ),
          max: this.parseNumberOrFallback(
            existingFileSizeConstrains.kb?.max,
            defaultFileSizeConstrains.kb.max
          )
        }
      };
      const hasCopyrightValidation =
        typeof channel.requireImageCopyright === "boolean"
          ? channel.requireImageCopyright
          : false;
      this.$set(channel, "requireImageCopyright", hasCopyrightValidation);
    },
    initializeChannelFileSizeConstrains() {
      if (!this.config) {
        return;
      }
      const allChannels = [
        ...(this.config.standard_channels ?? []),
        ...(this.config.own_channels ?? [])
      ];
      allChannels.forEach(channel => this.normalizeChannelConstrains(channel));
    },
    addOwnChannel() {
      this.config.own_channels.push({
        value: "",
        title: "",
        new: true,
        allowTextFormatting: false,
        allowPushNotifications: false,
        requireImageCopyright: false,
        fileSizeConstrains: _.cloneDeep(defaultConfig.fileSizeConstrains)
      });
    },
    getChannelExpansionKey(group, channel, index) {
      const channelValue = channel?.value || index;
      return `${group}-${channelValue}`;
    },
    toggleChannelExpansion(group, channel, index) {
      const key = this.getChannelExpansionKey(group, channel, index);
      const expandedChannels =
        group === "standard"
          ? this.expandedStandardChannels
          : this.expandedOwnChannels;
      if (expandedChannels.includes(key)) {
        const existingIndex = expandedChannels.indexOf(key);
        expandedChannels.splice(existingIndex, 1);
        return;
      }
      expandedChannels.push(key);
    },
    isChannelExpanded(group, channel, index) {
      const key = this.getChannelExpansionKey(group, channel, index);
      if (group === "standard") {
        return this.expandedStandardChannels.includes(key);
      }
      return this.expandedOwnChannels.includes(key);
    },
    hasImageConstraintUnit(channel, unit) {
      return channel?.fileSizeConstrains?.unit?.includes(unit);
    },
    channelHasActiveImageConstraints(channel) {
      return !!channel?.fileSizeConstrains?.active;
    },
    isImageConstraintMode(channel, mode) {
      const units = channel?.fileSizeConstrains?.unit ?? [];
      if (mode === "both") {
        return units.includes("px") && units.includes("kb");
      }
      if (mode === "px") {
        return units.length === 1 && units.includes("px");
      }
      if (mode === "kb") {
        return units.length === 1 && units.includes("kb");
      }
      return false;
    },
    setImageConstraintMode(channel, mode) {
      if (!channel?.fileSizeConstrains) {
        return;
      }
      channel.fileSizeConstrains.active = true;
      if (mode === "both") {
        channel.fileSizeConstrains.unit = ["px", "kb"];
        return;
      }
      channel.fileSizeConstrains.unit = [mode];
    },
    getImageConstraintSummary(channel) {
      if (!this.channelHasActiveImageConstraints(channel)) {
        return "nicht geprüft";
      }
      const imageConstrains = channel.fileSizeConstrains;
      const summaryParts = [];

      if (imageConstrains.unit.includes("px")) {
        const hasMinPx =
          Number.isFinite(imageConstrains.px?.min?.width) &&
          Number.isFinite(imageConstrains.px?.min?.height);
        const hasMaxPx =
          Number.isFinite(imageConstrains.px?.max?.width) &&
          Number.isFinite(imageConstrains.px?.max?.height);

        if (hasMinPx && hasMaxPx) {
          summaryParts.push(
            `${imageConstrains.px.min.width} × ${imageConstrains.px.min.height} px bis ${imageConstrains.px.max.width} × ${imageConstrains.px.max.height} px`
          );
        } else if (hasMinPx) {
          summaryParts.push(
            `ab ${imageConstrains.px.min.width} × ${imageConstrains.px.min.height} px`
          );
        } else if (hasMaxPx) {
          summaryParts.push(
            `bis ${imageConstrains.px.max.width} × ${imageConstrains.px.max.height} px`
          );
        }
      }

      if (imageConstrains.unit.includes("kb")) {
        const hasMinKb = Number.isFinite(imageConstrains.kb?.min);
        const hasMaxKb = Number.isFinite(imageConstrains.kb?.max);

        if (hasMinKb && hasMaxKb) {
          summaryParts.push(
            `${imageConstrains.kb.min} KB bis ${imageConstrains.kb.max} KB`
          );
        } else if (hasMinKb) {
          summaryParts.push(`ab ${imageConstrains.kb.min} KB`);
        } else if (hasMaxKb) {
          summaryParts.push(`bis ${imageConstrains.kb.max} KB`);
        }
      }

      return summaryParts.length ? summaryParts.join(" · ") : "geprüft";
    },
    addChangedDescription(index) {
      if (!this.changedDescription.includes(index))
        this.changedDescription.push(index);
    },
    isUnique(value) {
      return !(
        this.config.own_channels?.filter(channel => channel.value === value)
          ?.length > 1 || this.defaultChannelValues.includes(value)
      );
    },
    editOwnChannels(index) {
      if (!this.ownChannelsToUpdate.includes(index))
        this.ownChannelsToUpdate.push(index);
    },
    validateExpireInInput(value) {
      if (value < 0) this.config.expireInDays = 0;
      else this.config.expireInDays = value;
    },
    async removeOwnChannel(index) {
      try {
        const confirm = await this.$confirm(
          "Wollen Sie diesen Kanal wirklich löschen?",
          confirmWarningConfig
        );
        if (confirm) {
          const headers = await getTokenHeader();
          const channel = this.config.own_channels[index];
          if (channel?.new) {
            this.config.own_channels.splice(index, 1);
            return;
          }
          const response = await axios.put(
            `${env.news_api_client_url}config/ownchannels`,
            {
              channel: channel.value,
              configId: this.config._id
            },
            { headers }
          );
          if (response.status === 200) {
            await this.$store.dispatch("getNewsConfig");
            this.config.default_channels = this.config.default_channels.filter(
              ch => ch !== channel.value
            );
            this.config.channels = this.config.channels.filter(
              ch => ch !== channel.value
            );
            this.$store.dispatch("createSuccess", "Erfolgreich entfernt!");
            await this.saveConfig();
          } else this.$store.dispatch("createError");
        }
      } catch (e) {
        this.$store.dispatch("createError", e);
      }
    },
    changeActiveChannelSelection(checkValue, channel) {
      if (!checkValue) {
        this.changeDefaultChannelSelection(checkValue, channel);
      }
      if (checkValue) {
        if (!this.config.channels?.includes(channel))
          this.config.channels.push(channel);
      } else this.config.channels?.remove(channel);
    },
    editDefaultChannel(index) {
      if (
        index !== undefined &&
        index !== null &&
        !this.editChannel.includes(index)
      )
        this.editChannel.push(index);
    },
    changeDefaultChannelSelection(checkValue, channel) {
      if (checkValue) {
        if (!this.config.default_channels?.includes(channel))
          this.config.default_channels.push(channel);
      } else this.config.default_channels?.remove(channel);
    },
    cleanupOwnChannels(save = false) {
      if (this.config?.own_channels?.length) {
        this.config.own_channels.map(channel => {
          channel.value = channel.value.toLowerCase();
          if (save) {
            const firstChar = channel.value[0];
            channel.icon = `${
              isNaN(firstChar) ? "alpha" : "numeric"
            }-${firstChar}-box-outline`;
            delete channel.new;
          }
        });
      }
    },
    gotOnlyNumsAndLetters(value) {
      const regex = /^[a-zA-Z0-9]+$/;
      return regex.test(value);
    },
    validateOwnChannels() {
      this.errorList = [];
      if (this.config.own_channels.length) {
        this.config.own_channels.forEach((channel, index) => {
          if (!this.gotOnlyNumsAndLetters(channel.value)) {
            this.validationDialog = true;
            this.errorList.push({
              field: `Kanal-Typ: ${channel.value} (${index})`,
              validations: [
                "Typ darf keine Sonder- oder Leerzeichen enthalten!"
              ]
            });
          }
          if (!this.isUnique(channel.value)) {
            this.validationDialog = true;
            this.errorList.push({
              field: `Kanal-Typ: ${channel.value} (${index +
                1}) ist mehrfach vorhanden!`,
              validations: ["Muss einzigartig sein!"]
            });
          }
          if (!channel.value?.length) {
            this.validationDialog = true;
            this.errorList.push({
              field: `Kanal-Typ: ${index + 1}`,
              validations: ["Darf nicht leer sein!"]
            });
          }
        });
      }
    },
    async saveConfig(customMessage) {
      this.cleanupOwnChannels();
      this.validateOwnChannels();
      if (this.errorList.length) return;
      this.cleanupOwnChannels(true);
      let successMessage = this.config._id
        ? "Erfolgreich gespeichert!"
        : "Erfolgreich erstellt!";
      if (customMessage) successMessage = customMessage;
      let response;
      if (!this.config._id) response = await this.createConfig(this.config);
      else response = await this.updateConfig(this.config);

      if (response?.status === 200 || response?.status === 201) {
        await this.$store.dispatch("getNewsConfig");
        this.editChannel = [];
        await this.$store.dispatch("createSuccess", successMessage);
      }

      if (this.changedDescription.length) {
        await this.changedDescription.asyncForEach(async changedDescription => {
          await this.updateApiKeyDescription(changedDescription);
        });
        await this.$store.dispatch("getApiKeys");
      }
    },
    async updateApiKeyDescription(index) {
      try {
        const headers = getTokenHeader();
        const response = await axios.put(
          `${env.news_api_client_url}apiKey/${this.apiKeys[index]._id}`,
          this.apiKeys[index],
          { headers }
        );
        if (response.status === 200) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          await this.$store.dispatch("getNewsApiKeys");
          this.changedDescription = [];
        }
      } catch (e) {
        this.createError();
      }
    },
    async updateConfig(config) {
      const headers = getTokenHeader();
      try {
        return await axios.put(`${env.news_api_client_url}config`, config, {
          headers
        });
      } catch (error) {
        await this.$store.dispatch("createError", error);
      }
    },
    async createConfig(config) {
      config.id = this.currentPrincipal;
      config._id = this.currentPrincipal; //yes we need both
      const headers = getTokenHeader();
      try {
        return await axios.post(`${env.news_api_client_url}config`, config, {
          headers
        });
      } catch (error) {
        await this.$store.dispatch("createError", error);
      }
    },
    async addApiKey() {
      const newApiKey = {
        ...this.getDefaultApiKeyConfig(),
        apiKey: String.random(),
        description: "",
        config_ref: this.config._id
      };
      try {
        const headers = getTokenHeader();
        const response = await axios.post(
          `${env.news_api_client_url}apiKey/`,
          newApiKey,
          { headers }
        );
        if (response.status === 201) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          await this.$store.dispatch("getNewsApiKeys");
        } else {
          await this.$store.dispatch("createError");
        }
      } catch (e) {
        await this.$store.dispatch("createError", e);
      }
    },
    async apiKeyPreview(apiKey) {
      if (!this.isReadOnlyApiKey) {
        const confirmRes = await this.$confirm(
          `Möchten Sie Änderungen speichern?`,
          confirmWarningConfig
        );
        if (confirmRes) {
          await this.saveKey();
        }
      }
      await this.showApiKey(apiKey);
    },
    async showApiKey(apiKey) {
      setTimeout(async () => {
        window.open(
          `${this.$store.state.selectedPrincipal?.additional_data
            ?.newsWidgetUrl ?? env.news_widget_api_url}news?apiKey=${
            apiKey.apiKey
          }`,
          "_blank"
        );
      }, 200);
    },

    async copyApiKey(apiKey) {
      let clone = {
        ...apiKey,
        apiKey: String.random(),
        description: apiKey.description + " (Kopie)"
      };
      delete clone._id;
      if (clone.fallbackPicture?.url) {
        const newFile = await copyFileById(
          clone.fallbackPicture.id,
          getPictureUrlDatePath(clone.fallbackPicture.url)
        );
        clone.fallbackPicture = { ...clone.fallbackPicture, ...newFile };
      }
      delete clone._id;
      delete clone.updatedBy;
      delete clone.createdBy;

      try {
        const headers = getTokenHeader();
        const response = await axios.post(
          `${env.news_api_client_url}apiKey/`,
          clone,
          {
            headers
          }
        );
        if (response.status === 201) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          await this.$store.dispatch("getNewsApiKeys");
        } else {
          this.createError();
        }
      } catch (e) {
        this.createError();
      }
    },

    async removeApiKey(key) {
      const isConfirmed = await this.$confirm(
        "Wollen Sie diesen API Key wirklich löschen?",
        confirmWarningConfig
      );
      if (isConfirmed) {
        const fallbackImageId = key?.fallbackPicture?.id;
        if (fallbackImageId) await destroyFile("news", fallbackImageId);
        try {
          const headers = getTokenHeader();
          const response = await axios.delete(
            `${env.news_api_client_url}apiKey/${key._id}`,
            { headers }
          );
          if (response.status === 200) {
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gelöscht!"
            );
            await this.$store.dispatch("getNewsApiKeys");
          }
        } catch (e) {
          await this.$store.dispatch("createError", e);
        }
      }
    },
    editApiKey(index) {
      this.editedIndex = index;
      this.editedKey = Object.assign({}, this.getDefaultApiKeyConfig(), {
        ...this.apiKeys[index]
      });
      this.dialog = true;
    },
    closeKey() {
      this.editedIndex = null;
      this.editedKey = this.getDefaultApiKeyConfig();
      this.$refs.editView?.$refs?.fileInput?.reset();
      this.$refs.editView?.$refs?.logOverview?.resetLogs();
      this.dialog = false;
    },

    async saveKey(close) {
      if (this.isReadOnlyApiKey) {
        return;
      }

      if (this.$refs.editView.$refs.form.validate()) {
        try {
          if (this?.editedKey?.fallbackPicture instanceof File) {
            this.editedKey.fallbackPicture = await uploadFile(
              this.editedKey.fallbackPicture,
              this.config._id,
              "news",
              this.config._id
            );
          }

          const headers = getTokenHeader();
          const response = await axios.put(
            `${env.news_api_client_url}apiKey/${this.editedKey._id}`,
            this.editedKey,
            { headers }
          );
          if (response.status !== 200) {
            await this.$store.dispatch("createError", {
              text: "Beim Speichern ist ein Fehler aufgetreten.",
              error: response.data
            });
          } else {
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gespeichert!"
            );
            await this.$store.dispatch("getNewsApiKeys");
          }

          const logOverviewRef = this.$refs.editView?.$refs?.logOverview;
          const logsFetched = logOverviewRef?.logsFetched;
          logOverviewRef?.resetLogs();

          if (close) {
            this.closeKey();
          } else if (logsFetched) {
            logOverviewRef?.getLogs().then(null);
          }
        } catch (ex) {
          await this.$store.dispatch("createError", {
            text: "Beim Speichern ist ein Fehler aufgetreten.",
            error: ex
          });
        }
      }
    },
    onShareWithPrincipalsChange(selectedIds) {
      this.config.shareWithPrincipals = this.principals
        .filter(p => selectedIds.includes(p.id))
        .map(p => ({ id: p.id, name: p.name }));
    },
    moveUp(array, element) {
      this.move(array, element, -1);
    },
    moveDown(array, element) {
      this.move(array, element, 1);
    },
    move(array, element, delta) {
      let index = array.indexOf(element);
      let newIndex = index + delta;
      if (newIndex < 0 || newIndex === array.length) return;
      let indexes = [index, newIndex].sort();
      array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]);
    }
  },
  computed: {
    allChannels() {
      const standardChannels =
        this.$store.state.newsConfig.standard_channels ?? [];
      const ownChannels = this.$store.state.newsConfig.own_channels ?? [];
      return standardChannels.concat(ownChannels);
    },
    config() {
      return this.$store.state.newsConfig;
    },
    isReadOnlyApiKey() {
      if (this.isAdmin) {
        return false;
      }
      if (this.editedKey.userPermission === "edit") {
        return false;
      }
      return true;
    },
    apiKeys() {
      return this.$store.state.newsApiKeys;
    },
    isNewsAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:news_admin");
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    }
  },
  components: { InfoDialog, APIKeyList, NewsAPIKeyEditView, ValidationDialog },
  watch: {
    config: {
      immediate: true,
      handler() {
        this.initializeChannelFileSizeConstrains();
      }
    },
    dialog(newState) {
      if (newState) {
        const defaultApiKeyConfig = this.getDefaultApiKeyConfig();
        if (!this.editedKey.color) {
          this.editedKey.color = defaultApiKeyConfig.color;
        } else {
          for (const key of Object.keys(defaultApiKeyConfig.color)) {
            if (!this.editedKey.color[key]) {
              this.editedKey.color[key] = defaultApiKeyConfig.color[key];
            }
          }
        }
        if (!this.editedKey.newsIssuesWidget) {
          this.editedKey.newsIssuesWidget =
            defaultApiKeyConfig.newsIssuesWidget;
        }
        if (!this.editedKey.newsIssuesWidget.color) {
          this.editedKey.newsIssuesWidget.color =
            defaultApiKeyConfig.newsIssuesWidget.color;
        } else {
          for (const key of Object.keys(
            defaultApiKeyConfig.newsIssuesWidget.color
          )) {
            if (!this.editedKey.newsIssuesWidget.color[key]) {
              this.editedKey.newsIssuesWidget.color[key] =
                defaultApiKeyConfig.newsIssuesWidget.color[key];
            }
          }
        }
        if (!this.editedKey.cardBackgroundColor) {
          this.editedKey.cardBackgroundColor =
            defaultConfig.cardBackgroundColor;
        }
        this.$nextTick(() => this.$refs.editView?.setCodePreview());
      }
    }
  }
};
